import { React, useContext } from "react";
import { TbFilterDown } from "react-icons/tb";
import { FilterContext } from "../../context/Filter";
import Filter from "../Filter/VehicleFilter";

const Filteraccordion = ({ absolute }) => {
    const { isvOpen, setIsvOpen } = useContext(FilterContext);
    return (
        <div className={``}>
            <TbFilterDown
                title="Search"
                className="text-white cursor-pointer hover:text-blue-900  "
                size={24}
                onClick={() => setIsvOpen(!isvOpen)}
            />

        </div>
    );
};

export default Filteraccordion;
